import { LocalStorage } from "src/services/localStorageService";

import { createSlice } from "@reduxjs/toolkit";

import { RootState } from ".";

interface AppSlice {
    currentWorkspaceId: number | null;
}

const parsedId = Number(LocalStorage.getItem<string>("currentWorkspace"));
const initialState: AppSlice = {
    currentWorkspaceId: Number.isFinite(parsedId) && parsedId > 0 ? parsedId : null,
};

const appSlice = createSlice({
    name: "app",
    initialState,
    reducers: {
        setCurrentWorkspaceId: (state, action) => {
            LocalStorage.setItem("currentWorkspace", action.payload);
            state.currentWorkspaceId = action.payload;
        },
    },
});

export const AppReducer = appSlice.reducer;

export const { setCurrentWorkspaceId } = appSlice.actions;

export function selectCurrentWorkspaceId(state: RootState) {
    return state.app.currentWorkspaceId;
}
